import { Ban, ChevronDown, ChevronUp } from "lucide-react";
import ScooterCard from "./ScooterCard";

/**
 * Collapsed bottom section in /catalog showing scooters that are NOT available
 * on the picked date window (or in maintenance). Customer can expand it to
 * see them, but cards are non-clickable and dimmed.
 *
 * Props:
 *  - items (scooter array)
 *  - open (boolean)
 *  - onToggle ()
 *  - isEN, t
 */
export default function UnavailableSection({ items, open, onToggle, isEN, t }) {
  if (!items || items.length === 0) return null;
  return (
    <div
      className="border border-zinc-800 rounded-2xl bg-zinc-900/20 overflow-hidden"
      data-testid="catalog-unavailable-section"
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-5 py-3 text-left hover:bg-zinc-900/40 transition"
        data-testid="catalog-unavailable-toggle"
      >
        <span className="text-sm font-semibold text-zinc-300">
          <Ban className="w-4 h-4 inline mr-1.5 text-zinc-500" />
          {isEN
            ? `Not available on these dates · ${items.length}`
            : `Non disponibili in queste date · ${items.length}`}
        </span>
        {open
          ? <ChevronUp className="w-4 h-4 text-zinc-500" />
          : <ChevronDown className="w-4 h-4 text-zinc-500" />}
      </button>
      {open && (
        <div className="px-5 pb-5 pt-1">
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
            data-testid="catalog-unavailable-grid"
          >
            {items.map((s) => (
              <ScooterCard key={s.id} s={s} isUnavail={true} inDateFlow={true} isEN={isEN} t={t} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
